import { incYenOf } from '../../../lib/pricing';
const seminar = {
  // HeroSection
  'seminar.hero.homeLink': 'Home',
  'seminar.hero.currentPage': 'One-Day Taster Session',
  'seminar.hero.title': 'One-Day Taster Session: Introduction to Butler Etiquette',
  'seminar.hero.titleEn': 'ONE-DAY SEMINAR',
  'seminar.hero.lead': 'Six hours to experience the world of the butler. In the same classroom with the same instructors as the full programme — wearing white gloves for tea service and deportment practice.',
  'seminar.hero.imgAlt': 'The taster session in progress',

  // Overview
  'seminar.overview.label': 'OVERVIEW',
  'seminar.overview.title': 'Taster Session Overview',
  'seminar.overview.titleEn': 'One-Day Seminar Overview',
  'seminar.overview.name': 'One-Day Taster Session: Introduction to Butler Etiquette',
  'seminar.overview.nameEn': 'ONE-DAY SEMINAR',
  'seminar.overview.duration': '1 day',
  'seminar.overview.totalHours': '6 hours (4 x 90-minute sessions)',
  'seminar.overview.price': incYenOf('ac-trial'),
  'seminar.overview.currency': ' JPY',
  'seminar.overview.taxNote': '(tax incl.)',
  'seminar.overview.capacity': 'Max. 6 participants (small-group)',
  'seminar.overview.location': 'Our campus (Odaiba, Tokyo)',
  'seminar.overview.target': 'Those curious about the butler or concierge profession; those considering enrolling in the full programme; working professionals who wish to develop refined hospitality skills',
  'seminar.overview.scheduleLabel': 'Dates',
  'seminar.overview.scheduleText': 'Announced on our News page as sessions are scheduled',
  'seminar.overview.badge.0': 'One day, 6 hours',
  'seminar.overview.badge.1': 'Fee fully credited towards full course tuition',
  'seminar.overview.badge.2': 'Taught by the same instructors as the full programme',

  // Program
  'seminar.program.label': 'PROGRAM',
  'seminar.program.title': 'Programme for the Day',
  'seminar.program.titleEn': 'Programme Timeline',
  'seminar.program.0.time': 'Session 1 (10:00 – 11:30)',
  'seminar.program.0.title': 'The Butler Profession',
  'seminar.program.0.titleEn': 'The Butler Profession',
  'seminar.program.0.description': 'The same instructor as the full programme delivers a lecture covering the historical background of the butler profession and the range of modern career settings — private residences, hotels, and corporations. \n\nThe session also explores the differences between butlers in Britain and Japan, and the qualities the profession will demand in the future.',
  'seminar.program.1.time': 'Session 2 (11:45 – 13:15)',
  'seminar.program.1.title': 'Butler Deportment',
  'seminar.program.1.titleEn': 'Butler Comportment',
  'seminar.program.1.description': 'Students practise fundamental techniques one by one — wearing white gloves — including posture, gait, door service, and handing objects. \n\nWith mirror self-checks and individual guidance from the instructor, this is a fully hands-on session, not observation. \n\nBows are taught as three distinct forms used according to the occasion: the eshaku, inclining the upper body about fifteen degrees; the futsurei, about thirty degrees; and the keirei, about forty-five degrees. \n\nThe futsurei is the form most often used in daily duties, and for a courteous bow students also practise the correct order — speaking first, then bowing.',
  'seminar.program.2.time': 'Session 3 (14:00 – 15:30)',
  'seminar.program.2.title': 'Tea Service Practice',
  'seminar.program.2.titleEn': 'Tea Service Practice',
  'seminar.program.2.description': 'Each student works through the full sequence individually — tea leaf basics, temperature control, steeping time, and the art of a beautiful pour. Role-playing by serving one another brings the complete experience to life, from brewing to presenting. The use of genuine tea ware is a distinctive feature of the taster session. The basic sequence is to warm the pot and cups with hot water first, measure three grams of leaf per person, pour water drawn fresh and brought to a full boil, then cover the pot and steep for a standard three minutes (the quantity of leaf and the steeping time vary by product). In presenting the tea, the cup and saucer are set slightly to the right of the guest, the handle turned to the three o\'clock position so that it may easily be taken in the right hand, and the teaspoon laid in front of the cup on the saucer, parallel to the handle. Choosing a moment when the guest is not speaking, the butler approaches quietly from the right, says "Excuse me" and "Your tea, madam", and sets the saucer down without sound, supporting it with both hands; the rim of the saucer rests some three to five centimetres in from the edge of the table. For a left-handed guest, or where the arrangement of the table makes an approach from the right impracticable, the tea is presented from whatever place is natural to the situation. A refill is offered when about a quarter of the tea remains in the cup — before it has emptied entirely — with the words "May I pour you another?".',
  'seminar.program.3.time': 'Session 4 (15:45 – 17:15)',
  'seminar.program.3.title': 'Table Setting & Individual Consultation',
  'seminar.program.3.titleEn': 'Table Setting & Consultation',
  'seminar.program.3.description': 'After a hands-on introduction to a basic breakfast setting, the instructor outlines the three full courses and their key differences. \n\nThe session closes with a Q&A and, for those who wish, individual consultations to help identify the best learning pathway for each participant.',

  // GainItems
  'seminar.gain.label': 'WHY ATTEND',
  'seminar.gain.title': 'What You Will Experience',
  'seminar.gain.titleEn': 'What You Will Gain',
  'seminar.gain.0.title': 'Experience the atmosphere of authentic butler education first-hand',
  'seminar.gain.0.description': 'Learning in the same classroom with the same instructors as the full programme gives you a genuine sense of the Academy\'s environment and standard of teaching — the best way to ensure the full programme is right for you before committing.',
  'seminar.gain.1.title': 'Speak directly with an instructor about your career',
  'seminar.gain.1.description': 'The individual consultation in Session 4 gives you the opportunity to explore a career path tailored to your goals and background with the instructor — helping you to build a concrete picture of where the full programme could take you.',
  'seminar.gain.2.title': 'Understand the three full courses and find the right fit',
  'seminar.gain.2.description': 'You will leave with a clear understanding of the differences between Essential, Advanced, and Master — and a concrete picture of the typical learning journey from complete beginner to professional — making it straightforward to choose the course that suits you best.',
  'seminar.gain.3.title': 'Experience real service wearing white gloves',
  'seminar.gain.3.description': 'You will wear the white gloves that are the mark of the professional butler and practise tea service and deportment. A hands-on experience that gives you a vivid, concrete sense of what the full programme will feel like.',

  // MainCourses
  'seminar.courses.label': 'NEXT STEP',
  'seminar.courses.title': 'Pathways to the Full Programme',
  'seminar.courses.titleEn': 'Pathways to the Full Courses',
  'seminar.courses.description': 'The taster session fee (33,000 JPY, tax incl.) is credited in full against the tuition of any full course when you enrol within one year of attending.',
  'seminar.courses.currency': ' JPY',
  'seminar.courses.taxNote': '(tax incl.)',
  'seminar.courses.viewLink': 'View Course Details',
  'seminar.courses.creditNote': '* The taster session fee is credited in full against full course tuition (within one year of attending)',
  'seminar.courses.0.name': 'Essential Course',
  'seminar.courses.0.duration': '1 month · 8 days · 48 hours',
  'seminar.courses.0.description': 'The introductory programme, built from the ground up. Systematically establishes the foundation — from table manners to essential service skills — that underpins all butler practice.',
  'seminar.courses.1.name': 'Advanced Course',
  'seminar.courses.1.duration': '2 months · 12 days · 72 hours',
  'seminar.courses.1.description': 'The intermediate programme that includes the full content of Essential, then deepens specialist skills. Covers advanced hospitality including wine service and event management. Open to complete beginners.',
  'seminar.courses.2.name': 'Master Course',
  'seminar.courses.2.duration': '3 months · 16 days · 96 hours',
  'seminar.courses.2.description': 'The most advanced programme, including the full content of both Essential and Advanced, for those aiming for a professional career. Covers the full range of capabilities required of a head butler — management, leadership, and beyond. \n\nOpen to complete beginners.',

  // FAQSection
  'seminar.faq.label': 'FAQ',
  'seminar.faq.title': 'Frequently Asked Questions',
  'seminar.faq.titleEn': 'Frequently Asked Questions',
  'seminar.faq.footer': 'For further enquiries, please use our contact form.',
  'seminar.faq.0.question': 'I have no prior experience — is that fine?',
  'seminar.faq.0.answer': 'Absolutely. The taster session is an introductory programme designed for complete beginners. All tools and white gloves are provided on the day — please just bring a pen and notebook.',
  'seminar.faq.1.question': 'Is there a time limit on crediting the fee towards the full course?',
  'seminar.faq.1.answer': 'The credit applies to full course enrolments within one year of attending the taster session. Please refer to the information provided at the time of booking for full details.',
  'seminar.faq.2.question': 'Is there a dress code?',
  'seminar.faq.2.answer': 'Please wear smart casual clothing that allows freedom of movement — a collared shirt is recommended. A jacket is optional.',

  // CTASection
  'seminar.cta.label': 'APPLY NOW',
  'seminar.cta.title': 'Reserve Your Place',
  'seminar.cta.body': 'Upcoming dates are listed on our News page. Applications are accepted via the booking form.',
  'seminar.cta.note': '* Maximum 6 participants · First come, first served',
  'seminar.cta.apply': 'Apply Now',
  'seminar.cta.news': 'View Upcoming Dates',

  // RelatedPages
  'seminar.related.label': 'LEARN MORE',
  'seminar.related.title': 'Related Pages',
  'seminar.related.titleEn': 'Explore Further',
  'seminar.related.viewLink': 'Learn more',
  'seminar.related.0.title': 'Course Overview',
  'seminar.related.0.desc': 'View all three full courses',
  'seminar.related.1.title': 'Admissions',
  'seminar.related.1.desc': 'The enrolment process step by step',
  'seminar.related.2.title': 'FAQ',
  'seminar.related.2.desc': 'Answers to common questions about studying here',
  'seminar.related.3.title': 'Access',
  'seminar.related.3.desc': 'Directions to our Odaiba, Tokyo campus',

  // HeroSection extras
  'seminar.hero.admissionLink': 'Admissions',
  'seminar.hero.imgTitle': 'Japan Butler Academy — One-Day Taster Session: Introduction to Butler Etiquette',

  // SeminarOverview extras
  'seminar.overview.altTitle': 'Session Overview',
  'seminar.overview.tableCol.item': 'Item',
  'seminar.overview.tableCol.content': 'Details',
  'seminar.overview.row.duration': 'Duration',
  'seminar.overview.row.hours': 'Total Hours',
  'seminar.overview.row.price': 'Fee',
  'seminar.overview.row.capacity': 'Capacity',
  'seminar.overview.row.location': 'Venue',
  'seminar.overview.row.target': 'Suitable for',
  'seminar.overview.row.schedule': 'Dates',
  'seminar.overview.footerNote': '* All prices include tax. Enrolment closes once the class is full.',
  'seminar.overview.scheduleHtml': 'Dates are announced on our <a href="/news" class="text-accent-600 hover:text-accent-500 underline underline-offset-2 transition-colors">News page</a> as sessions are scheduled',

  // ProgramTimeline extras
  'seminar.program.altTitle': 'What Does the Taster Session Cover?',
  'seminar.program.description': 'This is a hands-on, practice-centred programme — not observation. Wearing white gloves, you will experience authentic butler education in a single day.',
  'seminar.program.note': '* The above is a standard programme outline. The order of activities may vary slightly depending on progress.',

  // GainSection extras
  'seminar.gain.altTitle': 'What You Will Gain from the Taster Session',

  // CourseIntro extras
  'seminar.courses.altTitle': 'The Full Programme Courses',
  'seminar.courses.viewDetail': 'Learn more',
  'seminar.courses.taxLabel': '(tax incl.)',

  // WhatToBring
  'seminar.bring.label': 'WHAT TO BRING',
  'seminar.bring.title': 'What to Bring & Dress Code',
  'seminar.bring.items.title': 'What to Bring',
  'seminar.bring.items.main': 'Please bring a pen and notebook only.',
  'seminar.bring.items.note': 'White gloves, practice tools, and textbooks are all provided on the day.',
  'seminar.bring.attire.title': 'Dress Code',
  'seminar.bring.attire.main': 'Please wear smart casual clothing that allows freedom of movement.',
  'seminar.bring.attire.note': 'A collared shirt is recommended. Jeans are not permitted. A jacket is optional.',

  // ImportantNotes
  'seminar.notes.title': 'Important Notes',
  'seminar.notes.0': 'The minimum number of participants is 2. If the session is cancelled due to insufficient enrolments, we will notify you at least 7 days before the date — at which point you will receive a full refund or the option to transfer to another date.',
  'seminar.notes.1': 'Recording of lectures (audio or video) is not permitted.',
  'seminar.notes.2': 'If you wish to attend with a child, please contact us in advance.',

  // FeeCarryOver
  'seminar.fee.lead': 'The taster session fee',
  'seminar.fee.message': 'Your',
  'seminar.fee.amount': ` ¥${incYenOf('ac-trial')}`,
  'seminar.fee.suffix': ' fee',
  'seminar.fee.target': 'is credited in full against',
  'seminar.fee.action': 'full course tuition',
  'seminar.fee.end': ' when you enrol.',

  // ApplicationForm
  'seminar.form.label': 'APPLICATION',
  'seminar.form.title': 'Book Your Place',
  'seminar.form.lead': 'Please complete the form below and proceed to confirm your details.',
  'seminar.form.contact.intro': 'You may also apply by telephone',
  'seminar.form.contact.or': 'or by email',
  'seminar.form.contact.also': '',
  'seminar.form.contact.hours': 'Office hours: Mon–Fri, 10:00–17:00',
  'seminar.form.field.name': 'Full Name',
  'seminar.form.field.furigana': 'Name (Furigana)',
  'seminar.form.field.email': 'Email Address',
  'seminar.form.field.phone': 'Telephone',
  'seminar.form.field.date': 'Preferred Date',
  'seminar.form.field.interest': 'Interest in the Full Programme',
  'seminar.form.field.question': 'Questions (optional)',
  'seminar.form.required': 'Required',
  'seminar.form.placeholder.name': 'e.g. Taro Shitsji',
  'seminar.form.placeholder.furigana': 'e.g. shitsuji taro',
  'seminar.form.placeholder.email': 'e.g. taro@example.com',
  'seminar.form.placeholder.phone': 'e.g. 090-1234-5678',
  'seminar.form.placeholder.date': 'e.g. Weekend in August, weekday evening, etc.',
  'seminar.form.placeholder.interest': 'Please select',
  'seminar.form.placeholder.question': 'Please feel free to note any questions you have.',
  'seminar.form.interest.considering': 'Actively considering',
  'seminar.form.interest.researching': 'Gathering information',
  'seminar.form.interest.undecided': 'Not yet decided',
  'seminar.form.submit': 'Proceed to Confirm',
  'seminar.form.error.name': 'Full name is required',
  'seminar.form.error.furigana': 'Furigana is required',
  'seminar.form.error.email.required': 'Email address is required',
  'seminar.form.error.email.invalid': 'Please enter a valid email address',
  'seminar.form.error.phone': 'Telephone number is required',
  'seminar.form.error.interest': 'Please indicate your interest in the full programme',
  'seminar.form.error.question': 'Please keep your message under 500 characters',

  // Last updated
  'seminar.lastUpdated': 'Last updated: 8 July 2026',
};

export default seminar;
